import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {CreateBaselineVersionInput, CreateBaselineVersionMutation} from './__generated__/CreateBaselineVersionMutation.graphql';

const mutation = graphql`
	mutation CreateBaselineVersionMutation($input: CreateBaselineVersionInput!) {
		createBaselineVersion(input: $input) {
			baselineVersion {
				id
			}
			project {
				id
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CreateBaselineVersionInput>,
	onSuccess?: RelayOnCompleted<CreateBaselineVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<CreateBaselineVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Version', 'Created');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
